import { render, staticRenderFns } from "./UiComments.vue?vue&type=template&id=6a27b522&"
import script from "./UiComments.vue?vue&type=script&lang=js&"
export * from "./UiComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports